import React, { useContext, useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthProvider/AuthProvider';

const Register = () => {

    const [error, setError] = useState('');
    const {createUser} = useContext(AuthContext);

    const handleSubmit = event => {
        event.preventDefault();
        const form = event.target;
        const name= form.name.value;
        const photoURL= form.photoURL.value;
        const email= form.email.value;
        const password= form.password.value;

        createUser(email, password);

    createUser(email, password)
    .then(result =>{
        const user = result.user;
        form.reset();
        form.reset();
        setError('');
      
    })
    .catch(error => 
        {setError(error.message);
    });
}
    return (
        <Form onSubmit={handleSubmit} className='w-sm-50 bg-primary bg-gradient bg-opacity-50 text-dark w-50 my-3 mx-auto border border-dark rounded-2 p-3'>
        <h2>Register</h2>
        <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control type="name" name="name" placeholder="Enter Full Name" required />
        </Form.Group>
        <Form.Group className="mb-3" controlId="formBasicEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" name="email" placeholder="Enter email" required />
        <Form.Group className="mb-3">
            <Form.Label>Photo URL</Form.Label>
            <Form.Control type="photoURL" name="photoURL" placeholder="Enter photoURL" />
        </Form.Group>
        </Form.Group>

        <Form.Group className="mb-3" controlId="formBasicPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" name="password" placeholder="Password" required/>
        </Form.Group>
        <Button variant="primary" type="submit">
            Submit
        </Button>
        <h6 className='mt-2'>Already have an account? <Link to={'/login'}>Log In here</Link></h6>
        <Form.Text className='text-danger'>Error : {error.slice(22,-2)}</Form.Text>
    </Form>
    );
};

export default Register;